
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/roster/jst/index';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <div class='pull-right group-categories-actions'>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.can_add_groups), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isHorizonCourse), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <a href=\"/courses/";
  if (helper = helpers.course_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.course_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "/groups#new\" class=\"btn btn-primary\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "add_group_set_f9809e11", "Add Group Set", options) : helperMissing.call(depth0, "t", "add_group_set_f9809e11", "Add Group Set", options)))
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "add_group_set_f9809e11", "Add Group Set", options) : helperMissing.call(depth0, "t", "add_group_set_f9809e11", "Add Group Set", options)))
    + "\">\n          <i class='icon-plus'></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.group_set", "Group Set", options) : helperMissing.call(depth0, "t", "courses.roster.index.group_set", "Group Set", options)))
    + "\n        </a>\n      ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <ul class=\"collectionViewItems ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all\" role=\"tablist\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "people_navigation_tabs_631401fe", "People navigation tabs", options) : helperMissing.call(depth0, "t", "people_navigation_tabs_631401fe", "People navigation tabs", options)))
    + "\" data-view=\"rosterTabs\"></ul>\n  ";
  return buffer;
  }

function program7(depth0,data) {
  
  
  return "\n      <div id=\"peopleFilterContainer\"></div>\n      ";
  }

function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <select\n        name=\"enrollment_role_id\"\n        data-view=\"roleSelect\"\n        aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.role_to_search", "Limit search to role", options) : helperMissing.call(depth0, "t", "courses.roster.index.role_to_search", "Limit search to role", options)))
    + "'\n        ></select>\n      ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.course)),stack1 == null || stack1 === false ? stack1 : stack1.concluded), {hash:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program12(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <a\n      href=\"#\"\n      class=\"btn pull-right icon-plus\"\n      id=\"addUsers\"\n      role=\"button\"\n      title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.cannot_add_users", "New users can not be added because this course is concluded", options) : helperMissing.call(depth0, "t", "courses.roster.index.cannot_add_users", "New users can not be added because this course is concluded", options)))
    + "'\n      aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.cannot_add_users", "New users can not be added because this course is concluded", options) : helperMissing.call(depth0, "t", "courses.roster.index.cannot_add_users", "New users can not be added because this course is concluded", options)))
    + "'\n      disabled data-tooltip>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.people", "People", options) : helperMissing.call(depth0, "t", "courses.roster.index.people", "People", options)))
    + "\n    </a>\n    ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <a\n      href=\"#\"\n      class=\"btn btn-primary pull-right icon-plus\"\n      id=\"addUsers\"\n      role=\"button\"\n      title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.title_add_people", "Add People", options) : helperMissing.call(depth0, "t", "courses.roster.index.title_add_people", "Add People", options)))
    + "'\n      aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.title_add_people", "Add People", options) : helperMissing.call(depth0, "t", "courses.roster.index.title_add_people", "Add People", options)))
    + "'\n      >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.people", "People", options) : helperMissing.call(depth0, "t", "courses.roster.index.people", "People", options)))
    + "</a>\n    ";
  return buffer;
  }

  buffer += "<div id=\"group_categories_tabs\" class=\"ui-tabs-minimal ui-tabs ui-widget ui-widget-content ui-corner-all\" style=\"display: block;\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canAddCategories), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isHorizonCourse), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div tabindex=\"0\" id=\"tab-0\" class=\"roster-tab tab-panel ui-tabs-panel\" style=\"min-height: 800px;\">\n    <div style=\"display: flex; flex-wrap: wrap; gap: 0.4em; align-items: stretch; margin-bottom: 0.5em;\">\n      <span id=\"search_input_container\"></span>\n      <input\n        type=\"hidden\"\n        name=\"search_term\"\n        data-view=\"inputFilter\"\n        placeholder='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.search_people", "Search people", options) : helperMissing.call(depth0, "t", "courses.roster.index.search_people", "Search people", options)))
    + "'\n        aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.index")
  },data:data},helper ? helper.call(depth0, "courses.roster.index.filter_field_description", "Search people. As you type in this field, the list of people will be automatically filtered to only include those whose names match your input.", options) : helperMissing.call(depth0, "t", "courses.roster.index.filter_field_description", "Search people. As you type in this field, the list of people will be automatically filtered to only include those whose names match your input.", options)))
    + "'\n        >\n      ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.can_manage_differentiation_tags), ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.allow_assign_to_differentiation_tags), options) : helperMissing.call(depth0, "ifAll", ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.can_manage_differentiation_tags), ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.allow_assign_to_differentiation_tags), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.add_users_to_course), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div id=\"userDiffTagManager\" style=\"margin-top:1.5em\"></div>\n    <div id=\"manageTagsTray\"></div>\n\n    <div class=\"v-gutter\">\n      <div data-view=\"resendInvitations\"></div>\n      <div data-view=\"users\"></div>\n    </div>\n\n  </div>\n  <div id=\"createUsersModalHolder\"></div>\n  <div id=\"differentiationTagTray\"></div>\n  <div id=\"userTagsModalContainer\"></div>\n  <div id=\"link_to_students_mount_point\"></div>\n  <div id=\"edit_sections_mount_point\"></div>\n  <div id=\"edit_roles_mount_point\"></div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  